const closeModals = () => {
  const openModals = document.querySelectorAll('.modal.is-open-modal');
  openModals.forEach((modal) => {
    modal.classList.remove('is-open-modal');
  });
  toggleBodyScrollLock(false);
};

// Open Modal
attachEvent('[data-modal-trigger]', 'click', (ev) => {
  const parentElement = ev.target.closest('[data-modal-parent]');
  const parentTrigger = ev.target.closest('[data-modal-trigger]');
  const targetModalValue = parentTrigger.getAttribute('data-modal-trigger');

  const targetModal = parentElement.querySelector(`[data-modal="${targetModalValue}"]`);
  if (targetModal) {
    targetModal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  }
  ev.preventDefault();
});

// Close Modal
attachEvent('[data-close-modal]', 'click', (ev) => {
  closeModals(ev.target);
  ev.preventDefault();
});

// Close Modal on ESC key press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeModals();
  }
});
